<template>
  <div class="home h-100">
    <NavbarMain />
    <div class="row h-100 m-0">
      <div class="col-xl-auto h-100 p-0 col-sm-12 h-sm-auto">
        <NavbarAdmin />
      </div>
      <div class="col">
        <DashboardComponent />
      </div>
    </div>
  </div>
</template>

<script>
import NavbarMain from "@/components/NavbarMain.vue";
import NavbarAdmin from "@/components/NavbarAdmin.vue";
import { mapState } from "vuex";
import DashboardComponent from "@/components/admin/DashboardComponent.vue";

export default {
  name: "Dashboard",
  data() {
    return {};
  },
  computed: {
    ...mapState(["auth"]),
  },
  methods: {},
  components: {
    NavbarMain,
    NavbarAdmin,
    DashboardComponent
  },
  created: function () {
  },
};
</script>